import { useCallback, useEffect, useState } from 'react';
import { store } from 'redux/store';

import {
  getSharesTitles,
  Params,
} from 'modules/partners/redux/sharesTitlesActions';

type UseSharesTitlesProps = {
  societyId: string | undefined;
  operationIds?: string[] | undefined;
  page: number;
  items: number;
  sortBy?: string;
  sortOrder?: string;
};

export const useSharesTitles = ({
  societyId,
  operationIds,
  page,
  items,
  sortBy,
  sortOrder,
}: UseSharesTitlesProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchSharesTitles = useCallback(
    async (searchTerm?: number | string) => {
      if (!societyId) return;
      setIsLoading(true);
      setIsError(false);
      try {
        const params: Params = {
          page,
          items,
          sortBy,
          sortOrder,
        };

        if (searchTerm) {
          params.searchTerm = searchTerm;
        }
        if (operationIds) {
          params.operationIds = operationIds;
        }
        await store.dispatch(getSharesTitles(societyId, params));
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    },
    [items, page, societyId, sortBy, sortOrder, operationIds]
  );

  useEffect(() => {
    fetchSharesTitles();
  }, [fetchSharesTitles]);

  return { isLoading, isError, actions: { fetchSharesTitles } };
};
